import moment from 'moment';
import * as React from 'react';
import { useCallback } from 'react';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Grid, Loader } from 'semantic-ui-react';

import { Card, List } from '../..';
import { localeData } from '../../../locales/data';
import { addModifiers } from '../../../shared/helpers';
import { FormattedMessageHelper } from '../../../shared/helpers/internationalization';
import analytics from '../../../shared/services/analytics/analytics';

import { EventsMainPropsGeneric } from './types';

const EventsMain = ({ isFetching, data, intl, history }: EventsMainPropsGeneric & RouteComponentProps) => {
  const handleEventBannerClick = useCallback(() => {
    analytics.trackCustomEvent('dashboard_click_event_image');
    history.push('/events');
  }, [history]);

  const handleViewCalendarClick = useCallback(() => {
    analytics.trackCustomEvent('dashboard_click_event_calendar');
  }, []);

  const handleEventDetailClick = useCallback(
    (id: string) => () => {
      analytics.trackCustomEvent('dashboard_click_event_detail', {
        event_label: id,
      });
    },
    []
  );

  const getEventLink = (id: string) => `/events/${id}`;

  const filteredData = data.filter(eventItem => moment(eventItem.get('start')).isSameOrAfter(moment())).take(4); //fix for past events

  return (
    <Grid.Column tablet={8} mobile={16} computer={5}>
      <Card
        wrapperClassName="intro-dashboard-step-5"
        title={intl.formatMessage({
          id: 'dashboardMain.dashboardMiddleBottomRow.events',
          defaultMessage: localeData.en['dashboardMain.dashboardMiddleBottomRow.events'],
        })}
        headerLink="/events"
        headerLinkLabel={intl.formatMessage({
          id: 'dashboardMain.dashboardMiddleBottomRow.viewCalendar',
          defaultMessage: localeData.en['dashboardMain.dashboardMiddleBottomRow.viewCalendar'],
        })}
        onHeaderLinkClick={handleViewCalendarClick}
      >
        <div className="dashboard__events-banner" onClick={handleEventBannerClick} />
        {isFetching ? (
          <div className="'dashboard__loader">
            <Loader active={true} inline="centered" size="massive" />
          </div>
        ) : (
          <List>
            <div>
              {filteredData && filteredData.size > 0 ? (
                <ul className="list__items">
                  {filteredData.map((announcement: any) => (
                    <Link
                      key={`${announcement.get('id')}`}
                      to={getEventLink(announcement.get('id'))}
                      className="event-link"
                      onClick={handleEventDetailClick(announcement.get('id'))}
                    >
                      <li
                        key={`${announcement.get('id')}`}
                        className={addModifiers(
                          'list__item',
                          ['event'].concat(
                            moment(announcement.get('start')).isSameOrAfter(moment()) ? ['bullet-highlight'] : ['crossed-out']
                          )
                        )}
                      >
                        <span className="list__name">{announcement.get('title')}</span>
                        <br />
                        {moment(announcement.get('start')).format('MMM. Do, YYYY')}&nbsp;
                        <FormattedMessageHelper id="app.at" />
                        &nbsp;
                        {moment(announcement.get('start')).format('h:mm A')}
                      </li>
                    </Link>
                  ))}
                </ul>
              ) : (
                <div>
                  <FormattedMessageHelper id="events.noResults.dashboard" />
                </div>
              )}
            </div>
          </List>
        )}
      </Card>
    </Grid.Column>
  );
};

export default withRouter(injectIntl(EventsMain));
